import React, { useState, useEffect } from "react";  // Importing useState and useEffect
import { Container, Row, Col, Button } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck } from "@fortawesome/free-solid-svg-icons";
import MetaManager from "../MetaManager";
import OtherServicesCarousel from "../OtherServicesCarousel";
import CallToAction from "../Home/CallToAction/CallToAction";
import BannerForm from './BannerForm';
import Faq from "./Faq";
import './Services.css';
const EventsAndFestivals  = () => {

  const  servicesFaqData = [
    { 
        question: "What is event and festival printing, and what materials does it include?  ", 
        answer: "Event and festival printing involves creating high-quality materials such as tickets, banners, flyers, and promotional items for seamless event organisation. It includes event ticket printing to ensure secure entry and branding materials like posters and stage backdrops. These materials enhance the attendee experience, promote the event, and provide necessary information. Event and festival printing caters to diverse occasions, from concerts and conferences to cultural festivals and trade shows. Customgns creaecreatee and professional look for the event."
    },
    { 
        question: "What are the benefits of custom event ticket printing services?   ", 
        answer: "Custom event ticket printing services provide tailored designs that align with your event’s theme and branding. Customisation allows you to include logos, unique artwork, and security features such as barcodes or holograms. High-quality printing ensures that tickets are durable and visually appealing, creating a positive impression among attendees. Customised tickets also help prevent counterfeiting and enhance the overall professionalism of your event. Whether for concerts, conferences, or festivals, custom tickets make your event stand out."
    },
    { 
        question: "Can Printingy handle bulk orders for event ticket printing?   ", 
        answer: "Yes, Printingy specialises in bulk event ticket printing, providing cost-effective solutions for large-scale events and festivals. Bulk printing reduces per-unit costs, making it an economical choice for event organisers and promoters. Our advanced printing technology ensures consistent quality across all tickets, regardless of the order size. We also offer quick turnaround times to ensure timely delivery for your events. Whether for a small concert or a major festival, Printingy efficiently and reliably supports your ticket printing needs."
    },
    { 
        question: "What materials are used for concert ticket printing?  ", 
        answer: "Our concert ticket printing services use premium materials such as thick cardstock and durable synthetic options. Cardstock is ideal for vibrant colours and high-resolution designs, while synthetic materials offer enhanced durability for handling and long-term use. To ensure ticket authenticity, we also incorporate advanced security features, including watermarks, UV inks, and barcodes. These materials are carefully chosen to provide a professional appearance and withstand the rigours of event handling."
    },
    { 
        question: "What industries and individuals benefit from events & festival printing services?  ", 
        answer: "Event organisers, concert promoters, and festival coordinators benefit significantly from event and festival printing services. Organisers rely on these services for tickets, promotional banners, and branding materials. Concert promoters use printed tickets and merchandise to enhance the attendee experience and promote their events. Festival coordinators require large-scale printing for signage, schedules, and entry management. Customised printing solutions ensure that events run smoothly, leaving a positive and lasting impression on attendees."
    },
];

    
const [pageTitle, setPageTitle] = useState('Printing for Events & Festivals');  // Dynamic title state

useEffect(() => {
  document.title = pageTitle; // Set the document title dynamically
}, [pageTitle]); // This will run whenever the pageTitle changes

  return (
    <div>
    <MetaManager 
  title=" Professional Event and Festival Printing Services"
  description="High-quality printing for events and festivals, including custom event and concert ticket printing services. Bulk events and festival printing solutions."
  keywords="Printing for Events & Festivals,
Events & Festivals Printing,
Event Tickets Printing,
Custom Event Ticket Printing Services,
Concert Ticket Printing

"
/>


      <header className="services-header text-center py-5  serviceheader">
        <Container>
          <Row className="align-item-cen">
            <Col lg={6}>
              <h1>Professional Printing for Events & Festivals  </h1>
              <h2 className="text-muted">Customised event and festival printing solutions for all occasions  </h2>
            </Col>

            {/* Contact Form on the Right Side */}
            <Col lg={6}>
              <div className="contact-form p-4 bg-white shadow-sm rounded" style={{ maxWidth: "400px", margin: "auto" }}>
                <h3 className="text-center mb-4">Get in Touch</h3>
                <BannerForm />
              </div>
            </Col>
          </Row>
        </Container>
      </header>

      <section className="services-overview ">
        <Container>
          <p>Printing is crucial for successful events and festivals, ensuring seamless organisation and memorable branding. Printingy specialises in Printing for Events & Festivals, providing high-quality events & festival printing services tailored to meet diverse needs.</p>
          <p>Our services include event ticket printing, offering precision and customisation for secure and visually appealing tickets. We provide custom event ticket printing services for unique branding, ensuring every ticket aligns with your event’s theme. Additionally, we specialise in concert ticket printing, creating durable and vibrant tickets for large-scale music events and festivals.</p>
          
          
        </Container>
      </section>

      <section className="why-choose py-5">
        <Container>
          <h2 className="text-center mb-4">Why Choose Printingy</h2>

          {/* Custom Flyer Printing Experts */}
          <div className="py-4 px-3 rounded mb-4">
            <Row className="al-center">
              <Col lg={6}>
              <h2 className="small-hed">Reliable Custom Event and Festival Printing Solutions</h2>
                <h3 className="large-hed">High-quality, durable printing for tickets and event materials  </h3>

                <ul className="list-unstyled">
                  <li>
                    <FontAwesomeIcon icon={faCheck} className="text-success me-2" />
                    Expert Printing for Events & Festivals with tailored designs.
                  </li>
                  <li>
                    <FontAwesomeIcon icon={faCheck} className="text-success me-2" />
                    Bulk events & festivals printing with competitive pricing.
                  </li>
                  <li>
                    <FontAwesomeIcon icon={faCheck} className="text-success me-2" />
                    Fully customised event ticket printing for branding and security.
                  </li>
                  <li>
                    <FontAwesomeIcon icon={faCheck} className="text-success me-2" />
                    Professional custom event ticket printing services with premium finishes.
                  </li>
                  <li>
                    <FontAwesomeIcon icon={faCheck} className="text-success me-2" />
                    Durable materials ensure long-lasting results for ticket handling.

                  </li>
                  <li>
                    <FontAwesomeIcon icon={faCheck} className="text-success me-2" />
                    High-resolution visuals and vibrant colours for impactful designs.
                  </li>
                  <li>
                    <FontAwesomeIcon icon={faCheck} className="text-success me-2" />
                    Quick turnaround times for bulk and customised orders.
                  </li>
                  <li>
                    <FontAwesomeIcon icon={faCheck} className="text-success me-2" />
                    Trusted solutions for event organisers, concert promoters, and festival coordinators.
                  </li>
                </ul>
                <Button variant="primary" className="mt-3">
                  Contact Us
                </Button>
              </Col>

              {/* Contact Form on the Right Side */}
              <Col lg={6}>
                <img
                  src="/assets/img/eventsandfest.jpg" // Path relative to the public folder
                  alt="Professional printing for events and festivals services"
                  className="img-fluid rounded"
                />
              </Col>
            </Row>
          </div>
          <CallToAction 
       title="Connect with us Today"
        description="Your trusted Partner for Bulk Printing Solutions..!"
      />
          {/* Professional Flyer Printing with Precision */}
          <div className="shadow-sm p-4 rounded">
            <h2 className="large-hed">Premium Event and Festival Printing Delivered On Time</h2>
            <h3 className="small-hed">Focus on your event planning while we manage your printing needs </h3>
            <p>At Printingy, we deliver exceptional events & festival printing using advanced technology and premium materials. Our custom event ticket printing services ensure professional and reliable results, whether for secure tickets or event branding materials.
            </p>
            <p>We prioritise efficiency and quality, guaranteeing timely delivery for all bulk and customised orders. Partner with Printingy for innovative printing solutions that elevate your events and festivals.
            </p>
          </div>
        </Container>
      </section>



      <div>
  {/* Existing Content */}
  <OtherServicesCarousel />
  {/* Other Content */}
</div>

<Faq faqData={servicesFaqData} />
   
    </div>
  );
};

export default EventsAndFestivals;
